import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	NgModule,
	Output,
} from '@angular/core';

import { ClientScreenDirectives } from '~app-client/core/directives';

@Component({
	standalone: false,

	selector: 'info-modals-slide',
	templateUrl: './modal-slide.component.html',
	styleUrls: ['./modal-slide.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'scrollbar-fade overflow-auto',
	},
})
export class InfoModalSlideComponent {
	@Input()
	public videoId?: string;

	@Output('tutorialOpened')
	public tutorialOpened$ = new EventEmitter<void>();

	constructor() {}

	public openVideo(): void {}
}

@NgModule({
	declarations: [InfoModalSlideComponent],
	imports: [CommonModule, ClientScreenDirectives],
	exports: [InfoModalSlideComponent],
})
export class InfoModalSlideModule {}
